import { useEffect, useRef } from 'react';

function usePrevious<T = unknown>(value: T) {
  const ref = useRef<T>(value);

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
}

export default usePrevious;
